/* Gonflair : cotillons aux couleurs de la charte (clic sur « Ajouter… », pluie à l’ouverture de l’accueil une fois par session). */
(function () {
  if (window.gfFete) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#2350FF', '#FFE600', '#FF2E9A', '#1FCB5A', '#FF2D3A'];
  var cv, ctx, parts = [], raf = 0;
  function size() { var d = window.devicePixelRatio || 1; cv.width = innerWidth * d; cv.height = innerHeight * d; ctx.setTransform(d, 0, 0, d, 0, 0); }
  function ensure() {
    if (cv) return;
    cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;left:0;top:0;width:100vw;height:100vh;margin:0;padding:0;border:0;background:transparent;overflow:visible;pointer-events:none;z-index:9999';
    // en « popover », la toile passe dans la couche du dessus : les cotillons restent visibles devant le tiroir du panier
    if (cv.showPopover) cv.setAttribute('popover', 'manual');
    document.body.appendChild(cv);
    ctx = cv.getContext('2d');
    size();
    addEventListener('resize', size);
  }
  function add(x, y, vx, vy) {
    parts.push({ x: x, y: y, vx: vx, vy: vy, w: 6 + Math.random() * 6, h: 8 + Math.random() * 8, r: Math.random() * 6.28,
      vr: (Math.random() - 0.5) * 0.3, c: COLORS[Math.random() * 5 | 0], t: 0, ph: Math.random() * 6.28, ribbon: Math.random() < 0.25 });
  }
  function tick() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.t++; p.vy += 0.16; p.vx *= 0.985; p.vy *= 0.985;
      p.x += p.vx + Math.sin(p.t / 10 + p.ph) * 0.7; p.y += p.vy; p.r += p.vr;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.scale(1, Math.cos(p.t / 6 + p.ph));
      ctx.fillStyle = p.c;
      if (p.ribbon) ctx.fillRect(-1.5, -p.h, 3, p.h * 2); else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
      if (p.y > innerHeight + 40) parts.splice(i, 1);
    }
    if (parts.length) raf = requestAnimationFrame(tick); else { raf = 0; ctx.clearRect(0, 0, innerWidth, innerHeight); try { if (cv.matches(':popover-open')) cv.hidePopover(); } catch (err) {} }
  }
  // remet la toile au premier plan (à rappeler après l’ouverture d’un tiroir ou d’une fenêtre)
  function raise() {
    if (!cv || !cv.showPopover) return;
    try { if (cv.matches(':popover-open')) cv.hidePopover(); cv.showPopover(); } catch (err) {}
  }
  function run() { raise(); if (!raf) raf = requestAnimationFrame(tick); }
  window.gfFete = {
    raise: raise,
    burst: function (x, y) {
      if (reduce) return; ensure();
      for (var i = 0; i < 90; i++) { var a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.9, s = 6 + Math.random() * 7; add(x, y, Math.cos(a) * s, Math.sin(a) * s); }
      run();
    },
    rain: function () {
      if (reduce) return; ensure();
      for (var i = 0; i < 170; i++) add(Math.random() * innerWidth, -20 - Math.random() * innerHeight * 0.6, (Math.random() - 0.5) * 2, 2 + Math.random() * 3);
      run();
    }
  };
  // au clic sur un bouton « Ajouter… » : pluie de cotillons depuis le bouton
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('a,button');
    if (!b || !/Ajouter/.test(b.textContent || '')) return;
    var r = b.getBoundingClientRect();
    window.gfFete.burst(e.clientX || r.left + r.width / 2, e.clientY || r.top);
  }, true);
  addEventListener('load', function () {
    if (!window.GF_RAIN) return;
    try { if (sessionStorage.getItem('gfRain')) return; sessionStorage.setItem('gfRain', '1'); } catch (err) {}
    setTimeout(window.gfFete.rain, 400);
  });
})();
